export const siteName = 'WAABM.music';

export const features = {
  blog: true, // set to true to enable the blog nav link and routes
};

export const tagline = 'we are all beautiful minds';

export const email = 'us@waabm.music';

export const social = [
  { 
    label: 'Instagram', 
    url: 'https://instagram.com' 
  },
  { 
    label: 'SoundCloud', 
    url: 'https://soundcloud.com' 
  },
  { 
    label: 'Bandcamp',
    url: 'https://bandcamp.com'  
  },
];
